(() => {
  if (window.alsReviewCardsClickHandler) return;
  window.alsReviewCardsClickHandler = true;

  const readPhotos = section => {
    const node = section.querySelector('[data-als-review-photos]');
    if (!node) return {map: {}, base: ''};
    try { return {map: JSON.parse(node.textContent) || {}, base: node.dataset.base || ''}; }
    catch { return {map: {}, base: ''}; }
  };

  const openPhoto = (section, src) => {
    const dialog = section.querySelector('[data-als-review-lightbox]');
    if (!dialog || typeof dialog.showModal !== 'function') { window.open(src, '_blank', 'noopener'); return; }
    dialog.querySelector('img').src = src;
    dialog.showModal();
  };

  document.addEventListener('click', (event) => {
    const photo = event.target.closest('[data-als-review-photo]');
    if (photo) {
      const section = photo.closest('[data-als-review-cards]');
      if (section) openPhoto(section, photo.dataset.alsReviewPhoto);
      return;
    }
    const lightbox = event.target.closest('[data-als-review-lightbox]');
    if (lightbox && (event.target === lightbox || event.target.closest('[data-als-review-lightbox-close]'))) {
      lightbox.close();
      return;
    }

    const button = event.target.closest('[data-als-review-more]');
    if (!button) return;
    const section = button.closest('[data-als-review-cards]');
    const grid = section?.querySelector('[data-als-review-grid]');
    const data = section?.querySelector('[data-als-review-data]');
    if (!grid || !data) return;
    const {map, base} = readPhotos(section);
    let reviews;
    try {
      reviews = JSON.parse(data.textContent).filter(review => review.content && review.content.length > 18);
    } catch { return; }
    // Same order as the Liquid render: photo reviews first, then the rest.
    const hasPhotos = review => Array.isArray(map[String(review.id)]) && map[String(review.id)].length > 0;
    reviews = reviews.filter(hasPhotos).concat(reviews.filter(review => !hasPhotos(review)));
    const shown = grid.children.length;
    const fragment = document.createDocumentFragment();
    for (const review of reviews.slice(shown, shown + 12)) {
      const item = document.createElement('li');
      const rating = Math.max(0, Math.min(5, Number(review.rating) || 0));
      const stars = Array.from({length: 5}, (_, index) => '<span' + (index >= rating ? ' class="is-empty"' : '') + '>&#9733;</span>').join('');
      item.className = 'als-review-cards__card';
      item.dataset.alsReviewCard = '';
      item.innerHTML = '<div class="als-review-cards__card-top"><span class="als-review-cards__stars" role="img" aria-label="' + rating + ' out of 5 stars">' + stars + '</span>' + (review.verified ? '<span class="als-review-cards__verified">Verified buyer</span>' : '') + '</div><blockquote></blockquote><footer><span class="als-review-cards__avatar" aria-hidden="true"></span><span><strong></strong><small></small></span></footer>';
      item.querySelector('blockquote').textContent = review.content;
      item.querySelector('.als-review-cards__avatar').textContent = (review.author || 'C').slice(0,1).toUpperCase();
      item.querySelector('strong').textContent = review.author || 'Customer';
      if (review.location) item.querySelector('small').textContent = review.location;
      else item.querySelector('small').remove();
      if (hasPhotos(review)) {
        const files = map[String(review.id)].slice(0, 6);
        const list = document.createElement('ul');
        list.className = 'als-review-cards__photos';
        list.setAttribute('role', 'list');
        files.forEach((file, index) => {
          const li = document.createElement('li');
          const btn = document.createElement('button');
          const img = document.createElement('img');
          btn.type = 'button';
          btn.className = 'als-review-cards__photo';
          btn.dataset.alsReviewPhoto = base + file;
          btn.setAttribute('aria-label', 'View customer photo ' + (index + 1) + ' of ' + files.length);
          img.src = base + file + '?width=480';
          img.alt = 'Customer photo from ' + (review.author || 'a customer');
          img.width = 480; img.height = 480;
          img.loading = 'lazy'; img.decoding = 'async';
          btn.append(img); li.append(btn); list.append(li);
        });
        item.querySelector('blockquote').before(list);
      }
      fragment.append(item);
    }
    grid.append(fragment);
    if (grid.children.length >= reviews.length) button.hidden = true;
  });
})();
